
<div class="eye-view-pallet-details">
  <div class="row  text-md-center">
    <div class="col-3 mogo-bold eye-view-details-header">
      CHEP
    </div>
    <div class="col-3 mogo-bold eye-view-details-header">
      LOSCAM
    </div>
    <div class="col-3 mogo-bold eye-view-details-header">
      Other
    </div>
    <div class="col-3 mogo-bold eye-view-details-header">
      Total Lifts
    </div>
  </div>

  <div class="row  text-md-center">
    <div class="col-3 eye-view-details-content">
      {{ palletDetails.chep }}
    </div>
    <div class="col-3 eye-view-details-content">
      {{ palletDetails.loscam }}

    </div>
    <div class="col-3 eye-view-details-content">
      {{ palletDetails.other }}

    </div>
    <div class="col-3 eye-view-details-content">
      {{ palletDetails.totalLifts }}

    </div>
  </div>
</div>
